import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "../../ExternalDependencies";
import { dict } from "./dict";
import { defaultConfig } from "./config";
import { ChangePassword } from "./ui";
import { ChangePasswordState } from "./state";
import { EmptyValidator, RegexValidator, NotMatchValidator, FieldErrorValidator, DomIdProvider } from "../../helpers";
export class ChangePasswordRoot extends BaseBlock {
    constructor(domId, options) {
        super(domId, options);
        this.config = Object.assign(Object.assign({}, defaultConfig), (options.cms || {}));
        this.dictionary = Object.assign(Object.assign({}, dict), (options.dict || {}));
        const newPassValidators = [
            new EmptyValidator(this.dictionary["password-details-empty-error"]),
            new RegexValidator(this.dictionary["password-details-rule-error"], this.config.ValidationRule)
        ];
        const confPassValidators = [
            new EmptyValidator(this.dictionary["password-confirm-empty-error"])
        ];
        const diffPassValidators = [
            new NotMatchValidator(this.dictionary["password-details-not-match"])
        ];
        const newPassValidator = new FieldErrorValidator(newPassValidators);
        const confPassValidator = new FieldErrorValidator(confPassValidators);
        const diffPassValidator = new FieldErrorValidator(diffPassValidators);
        this.state = new ChangePasswordState({
            cms: this.config,
            dict: this.dictionary,
            newPassValidator,
            confPassValidator,
            diffPassValidator,
            playerDataConnection: options.dataProvider
        });
    }
    activate() {
        this.state.activate().then(() => { }).catch((reason) => { alert(reason); });
        return super.activate(React.createElement(ChangePassword, { state: this.state, config: this.config, dict: this.dictionary, domIdProvider: new DomIdProvider(this.config.blockUniqueId) }));
    }
    deactivate() {
        this.state.deactivate();
        return this;
    }
}
window["ChangePassword"] = ChangePasswordRoot;
broadcastBlockLoad("ChangePassword");
//# sourceMappingURL=index.js.map